import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { DetectViewportDirectiveModule } from "@hermes/utils-generic/directives/detect-viewport";

import { ImageResizerComponent } from "./image-resizer.component";

@NgModule({
    imports: [CommonModule, DetectViewportDirectiveModule],
    declarations: [ImageResizerComponent],
    exports: [ImageResizerComponent],
})
export class ImageResizerModule {}
